export { default as InnerPanelTabs } from "./InnerPanelTabs";
